/* eslint-disable */
import React, { useState } from 'react';
import { Grid, IconButton, InputAdornment } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import SectionCard from './SectionCard';
import { StyledField } from './helpers';

const EyeAdornment = ({ visible, onToggle }) => (
  <InputAdornment position="end">
    <IconButton onClick={onToggle} size="small" edge="end" tabIndex={-1}>
      {visible
        ? <VisibilityOffOutlinedIcon sx={{ fontSize: 18, color: '#8398AE' }} />
        : <VisibilityOutlinedIcon sx={{ fontSize: 18, color: '#8398AE' }} />}
    </IconButton>
  </InputAdornment>
);

const PasswordSection = ({ data, onChange }) => {
  const [show, setShow] = useState({ actuel: false, nouveau: false, confirmer: false });
  const toggle = (key) => setShow((s) => ({ ...s, [key]: !s[key] }));

  return (
    <SectionCard
      id="mot-de-passe"
      title="Changement de mot de passe"
      subtitle="Mettez à jour votre mot de passe pour sécuriser votre compte"
    >
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <StyledField
            label="Mot de passe actuel"
            name="motDePasseActuel"
            type={show.actuel ? 'text' : 'password'}
            value={data.motDePasseActuel}
            onChange={onChange}
            autoComplete="current-password"
            InputProps={{ endAdornment: <EyeAdornment visible={show.actuel} onToggle={() => toggle('actuel')} /> }}
          />
        </Grid>
        <Grid item xs={4}>
          <StyledField
            label="Nouveau mot de passe"
            name="nouveauMotDePasse"
            type={show.nouveau ? 'text' : 'password'}
            value={data.nouveauMotDePasse}
            onChange={onChange}
            autoComplete="new-password"
            InputProps={{ endAdornment: <EyeAdornment visible={show.nouveau} onToggle={() => toggle('nouveau')} /> }}
          />
        </Grid>
        <Grid item xs={4}>
          <StyledField
            label="Confirmer nouveau mot de passe"
            name="confirmerMotDePasse"
            type={show.confirmer ? 'text' : 'password'}
            value={data.confirmerMotDePasse}
            autoComplete="new-password"
            onChange={onChange}
            InputProps={{ endAdornment: <EyeAdornment visible={show.confirmer} onToggle={() => toggle('confirmer')} /> }}
          />
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default PasswordSection;